import { tableHeadPrivatePensionSecondCopy } from './constants';

export const getFlex = (index: number) => {
  const currentHead = tableHeadPrivatePensionSecondCopy.find((_, i) => i === index);
  return currentHead?.flex || 1;
};
